import axios from "axios";
import qs from "qs";
import { currencyFormatter } from "./dynamic-pricing";

const SCREENPRESSO_PRO = {
  path: "screenpresso-pro",
  store: "https://learnpulse.test.onfastspring.com/popup-learnpulse/builder",
};
const SCREENPRESSO_ENTERPRISE = {
  path: "screenpresso-enterprise",
  store:
    "https://screenpresso.test.onfastspring.com/popup-screenpresso/builder",
};

export const fetchPrice = product => (
  quantity,
  { reseller } = { reseller: false }
) => {
  const uri = product.store;
  const data = {
    put: JSON.stringify({
      items: [{ path: product.path, quantity }],
      coupon: reseller ? "RESELLER_2019" : "",
    }),
  };
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  return axios
    .post(uri, qs.stringify(data), config)
    .then(response => {
      const formatCurrency = currencyFormatter(
        response.data.country,
        response.data.currency
      );

      const price = {
        quantity,
        fastspring: {
          product,
        },
        totalWithTax: response.data.totalWithTax,
        totalWithoutTax: formatCurrency(
          response.data.totalWithTaxValue - response.data.taxValue
        ),
        totalWithTaxWithoutDiscount: formatCurrency(
          response.data.totalWithTaxValue + response.data.discountTotalValue
        ),
        tax: response.data.tax,
        isDiscount: response.data.discountTotalValue > 0,
        discountTotal: response.data.discountTotal,
        country: response.data.country,
      };
      /*
      {
        discountTotal: "6,00 €",
        discountTotalPercent: "10 %",
        isDiscount: true,
        fastspring: {
          product: {
            path: "screenpresso-pro", 
            store: "https://learnpulse.test.onfastspring.com/popup-learnpulse/builder"
          },
        },
        quantity: 2,
        tax: "9,00 €",
        totalWithTax: "53,98 €",
        totalWithTaxWithoutDiscount: "59,98 €",
        country: "FR"
      }
      */
      return price;
    })
    .catch(error => {
      // Do not throw
      console.error(error.message);
    });
};

export const fetchProPrice = fetchPrice(SCREENPRESSO_PRO);
export const fetchEnterprisePrice = fetchPrice(SCREENPRESSO_ENTERPRISE);

export const ProCheckout = (quantity = 1) => {
  const s = {
    //Reset the cart session  to remove everything added to the cart previously.
    reset: true,
    //Define the product path(s) and the quantity to add.
    products: [
      {
        path: "screenpresso-pro",
        quantity,
      },
    ],
    checkout: true,
  };
  fastspring.builder.push(s);
};

export const enterpriseCheckout = () =>
  "https://screenpresso.test.onfastspring.com/screenpresso-enterprise";

/*

https://www.fastspringexamples.com/popup/addQuantity

Price: <span data-fsc-item-path="screenpresso-pro" data-fsc-item-price></span>
(incl. tax: <span data-fsc-order-tax> </span>)

<script
    id="fsc-api"
    src="https://d1f8f9xcsvx3ha.cloudfront.net/sbl/0.8.0/fastspring-builder.min.js"
    type="text/javascript"
    data-storefront="learnpulse.test.onfastspring.com/popup-learnpulse">
</script>
  
<script>
	fastspring.builder.reset();
	fastspring.builder.add("screenpresso-pro");
</script>


=================


Price: <span data-fsc-item-path="screenpresso-enterprise" data-fsc-item-price></span>
(incl. tax: <span data-fsc-order-tax> </span>)

<script
    id="fsc-api"
    src="https://d1f8f9xcsvx3ha.cloudfront.net/sbl/0.8.0/fastspring-builder.min.js"
    type="text/javascript"
    data-storefront="screenpresso.test.onfastspring.com/popup-screenpresso">
</script>

<script>
	fastspring.builder.reset();
	fastspring.builder.add("screenpresso-enterprise");
</script>

*/
